<div *ngIf="selectedTemplateDetails" class="p-grid" style="margin-bottom: 6px;">
    <ng-container *ngFor="let col of questionnaireDetailCols">
      <div class="p-col" *ngIf="col.show && selectedTemplateDetails">
        <div class="leaddesc card">
          <div class="label">{{col.header}}</div>
          <div>
            {{selectedTemplateDetails[col.field]}}
          </div>
        </div>
      </div>
    </ng-container>
</div>

<p-panel *ngFor="let que of questionAns; let i=index" styleClass="question-panel">
    <ng-template pTemplate="header">
        <h6 class="p-mb-0">{{que.questionNo}} - {{que.name}} ({{que.questionType}}) ({{que.responseCount}} Responses)</h6>
        <span class="btnBars p-ml-2  hide-for-pdf" (click)="showAnswer(que)" [pTooltip]="'View Responses'"><i class="pi pi-window-maximize"></i></span>
    </ng-template>

    <ng-container *ngIf="que.questionTypeId == 1">
        <div class="p-grid">
            <div class="p-col-12">
                <p-chart type="bar" (onDataSelect)="onDataSelect($event,que)" [data]="que.dataSheet" [height]="250" [options]="options"></p-chart>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="que.questionTypeId == 2 || que.questionTypeId == 7">
        <div class="p-grid">
            <div class="p-col-6">
                <p-chart type="bar" (onDataSelect)="onDataSelect($event,que)" [data]="que.dataSheet" [height]="250" [options]="options"></p-chart>
            </div>
            <div class="p-col-6">
                <p-chart type="pie" (onDataSelect)="onDataSelect($event,que,'pie')" [data]="que.pieData" [height]="250" [options]="options"></p-chart>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="que.questionTypeId == 3">
        <div class="p-grid">
            <div class="p-col-6">
                <p-chart type="doughnut" (onDataSelect)="onDataSelect($event,que,'doughnut')" [data]="que.pieData" [height]="250" [options]="options"></p-chart>
            </div>
            <div class="p-col-6">
                <p-chart type="bar" (onDataSelect)="onDataSelect($event,que)" [data]="que.dataSheet" [height]="250" [options]="options"></p-chart>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="que.questionTypeId == 4 || que.questionTypeId == 5 || que.questionTypeId == 6 || que.questionTypeId == 8">
        <div class="p-grid">
            <div class="p-col-12">
                <p-chart type="doughnut" (onDataSelect)="onDataSelect($event,que,'doughnut')" [data]="que.pieData" [height]="250" [options]="options"></p-chart>
            </div>
        </div>
    </ng-container>
</p-panel>

<p-dialog [(visible)]="displayAnswer" [style]="{width: '80vw'}" [modal]="true" [responsive]="true">
        <ng-template pTemplate="header">
            <div class="p-d-flex align-items-center p-jc-between" style="width: 100%; ">
                <div style="flex-grow: 1;">
                    <h5>{{questionTemp.questionNo}} - {{ questionTemp?.name }}</h5>
                </div>
                <div *ngIf="selectedTabIndex==0" class="p-text-right">
                    <div class="p-mr-3">
                        <p-button (click)="openResponsesAsPDF(true)" class="p-mr-2" icon="pi pi-print"></p-button>
                        <p-button (click)="downloadAsXLS()" class="p-mr-2" icon="pi pi-download"></p-button>
                    </div>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="content">
            <p-tabView (onChange)="changeTab($event)" [(activeIndex)]="selectedTabIndex">
                <p-tabPanel header="Responses" [index]="0">
                    <ng-container *ngTemplateOutlet="responseViewTable"></ng-container>
                </p-tabPanel>
                <p-tabPanel *ngIf="questionTemp?.questionOptions?.length>0" header="Options" [index]="1">
                    <ul style="list-style: none;" class="p-p-0">
                        <li *ngFor="let ans of questionTemp?.questionOptions; let i = index" class="p-mb-3">
                            <div class="p-d-flex queBlock">
                                <div style="width: 3rem;">
                                    <span class="btnBars" (click)="showSubQue = !showSubQue" *ngIf="ans?.subQuestions?.length > 0">
                                        <i class="pi pi-chevron-down" *ngIf="showSubQue"></i>
                                        <i class="pi pi-chevron-right" *ngIf="!showSubQue"></i>
                                    </span>
                                </div>

                                <div style="flex-grow: 1;" class="p-mt-1">
                                    <span>{{i+1}}. {{ans.answerValue}} ({{ ans?.responseCount }})</span>
                                    <ul *ngIf="ans?.subQuestions?.length > 0 && showSubQue" style="list-style: none;" class="p-mt-3">
                                        <li *ngFor="let s of ans.subQuestions; let j = index">
                                            {{j+1}}. {{s?.answerValue}} ({{ s?.responseCount }})
                                            <span *ngIf="ans.subQuestions.length > 0" class="p-ml-1 p-mt-1">({{s.type}})</span>

                                            <ul style="list-style: none;" class="p-mt-3">
                                                <li *ngFor="let c of s.answers; let m = index" class="p-mb-2">
                                                    <p-radioButton name="groupname3" [value]="c"
                                                    *ngIf="s?.questionTypeId == 1 || s?.questionTypeId == 3 || s?.questionTypeId == 4"
                                                    class="p-mr-2"></p-radioButton>
                                                    <p-checkbox name="groupname4" value="val1" *ngIf="s?.questionTypeId == 2" class="p-mr-2"></p-checkbox>
                                                    {{m+1}}. {{c.answerValue}}
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </li>
                    </ul>
                </p-tabPanel>
             </p-tabView>
        </ng-template>

</p-dialog>

<p-dialog [header]="questionTempResponse?.name"  [(visible)]="displayAnswerResponses" [style]="{width: '80vw'}" [modal]="true">

    <div class="p-d-flex align-items-center p-jc-between p-mb-3">
        <div style="flex-grow: 1;">
            <h6>Ans: {{ questionTempResponse?.answerValue }} ({{ questionTempResponse?.totalresponsecount }})</h6>
        </div>
        <div class="p-text-right">
            <div>
                <p-button (click)="openResponsesAsPDF()" class="p-mr-2" icon="pi pi-print"></p-button>
                <p-button (click)="downloadAsXLS()" class="p-mr-2" icon="pi pi-download"></p-button>
            </div>
        </div>
    </div>

    <ng-container *ngTemplateOutlet="responseViewTable"></ng-container>

</p-dialog>

<ng-template #responseViewTable>
    <div *ngIf="questionTempResponse" class="card">
        <p-table #questionnaireRespnses
        [columns]="questionnaireResponseCols"
        [lazy]="false"
        [value]="questionTempResponse?.questionAns"
        [rows]="15"
        [rowsPerPageOptions]="[15,30,50,100]"
        [paginator]="true"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        appendTo="body"
        [style]="{width:'100%'}"
        [scrollable]="true">
        <ng-template pTemplate="caption">
            <div class="table-header p-text-right">
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="questionnaireRespnses.filterGlobal($event.target.value, 'contains')" placeholder="Search..." />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="colgroup" let-columns>
            <colgroup>
            <ng-container *ngFor="let col of columns">
                <col *ngIf="col.show" style="width:auto">
            </ng-container>
            </colgroup>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
            <tr>
            <ng-container *ngFor="let col of columns">
                <th *ngIf="col.show" [pSortableColumn]="col.field">
                    {{col.header}}
                </th>
            </ng-container>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr [pSelectableRow]="rowData" [pContextMenuRow]="rowData">
            <ng-container *ngFor="let col of columns">
                <td *ngIf="col.show" style="text-align: left;">

                    <!-- <a class="btnBars popup-link" *ngIf="col.field=='storeName'" (click)="setDataDetails(rowData)">{{rowData[col.field]}}</a> -->
                    <ng-container *ngIf="col.field=='answerValue'">
                        <a *ngIf="questionTempResponse.questionTypeId == 5 || questionTempResponse.questionTypeId == 6" class="btnBars popup-link" (click)="viewAddedAttachments(rowData)">{{rowData[col.field]}}</a>
                        <span *ngIf="questionTempResponse.questionTypeId != 5 && questionTempResponse.questionTypeId != 6">{{rowData[col.field]}}</span>
                    </ng-container>
                    <ng-container *ngIf="col.field!='answerValue'">{{rowData[col.field]}}</ng-container>


                </td>
            </ng-container>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
            <tr>
            <td colspan="7"><div class="p-text-center">No responses</div></td>
            </tr>
        </ng-template>
        </p-table>
    </div>
</ng-template>


<p-dialog [header]="questionTempResponse?.name"  [(visible)]="displayAttachmentResponses" [style]="{width: '50vw'}" [modal]="true">
    <h6>Ans: {{ tempAnswerResponse?.answerValue }}</h6>
    <h6>Name: {{ tempAnswerResponse?.storeName }}</h6>

    <div *ngIf="tempAttachments.length>0" class="card">
        <app-image-slider *ngIf="questionTempResponse?.questionTypeId == 5" [attachments]="tempAttachments"></app-image-slider>
        <app-attachment-list *ngIf="questionTempResponse?.questionTypeId != 5" [attachments]="tempAttachments"></app-attachment-list>
    </div>

</p-dialog>


<p-toast position="top-right" [baseZIndex]="10000"></p-toast> 
